<div class="evento-item" *ngIf="template == null">
    <div class="header">
        <div class="icon">
            <i class="material-icons">event</i>
        </div> 
        <span class="data-evento">{{evento.data_evento}}</span>  
        <span class="horario-evento">
            <i class="material-icons">schedule</i>
            {{evento.horario}}
        </span>
        <h3>{{evento.nome}}</h3> 
        <div class="content-link" *ngIf="evento.link_ativo">
            <a [href]="evento.link" [title]="evento.nome" target="_blank">
                Se inscreva aqui
            </a>
        </div>    
    </div>   
</div>   
<div class="evento-item template-home box-sombra" *ngIf="template == 'home'">
    <div class="header"> 
        <div class="icon">
            <i class="material-icons">event</i>
        </div> 
        <span class="data-evento">{{evento.data_evento}}</span>  
        <span class="horario-evento">
            <i class="material-icons">schedule</i>
            {{evento.horario}}
        </span>
        <h3>{{evento.nome}}</h3> 
        <div class="content-link" *ngIf="evento.link_ativo">
            <a [href]="evento.link" [title]="evento.nome" target="_blank">
                Se inscreva aqui
            </a>
        </div>    
    </div>   
</div>    